import { jsx as i, Fragment as _, jsxs as S } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S as z } from "./index-DoOsnuB6.js";
import { c as y } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import { S as x } from "./Spinner-Drz3dWpe.js";
import './Button.css';const h = "_buttonBase_1q0sf_75", B = "_button_1q0sf_75", b = "_xxSmallSize_1q0sf_119", q = "_xSmallSize_1q0sf_127", g = "_smallSize_1q0sf_135", p = "_defaultSize_1q0sf_143", v = "_largeSize_1q0sf_149", F = "_iconSize_1q0sf_157", N = "_primary_1q0sf_166", W = "_secondary_1q0sf_175", j = "_tertiary_1q0sf_188", V = "_ghost_1q0sf_210", k = "_ghostBrand_1q0sf_211", w = "_outline_1q0sf_251", C = "_surface_1q0sf_264", R = "_isFullWidth_1q0sf_270", A = "_rounded_1q0sf_274", t = {
  buttonBase: h,
  button: B,
  xxSmallSize: b,
  xSmallSize: q,
  smallSize: g,
  defaultSize: p,
  largeSize: v,
  iconSize: F,
  primary: N,
  secondary: W,
  tertiary: j,
  ghost: V,
  ghostBrand: k,
  outline: w,
  surface: C,
  isFullWidth: R,
  rounded: A
}, D = y(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), f = c(
  ({ asChild: l = !1, className: a, disabled: e, pressed: s, ...o }, n) => {
    const r = l ? z : "button", m = s === void 0 ? void 0 : { "aria-pressed": s, "data-state": s ? "on" : "off" };
    return /* @__PURE__ */ i(
      r,
      {
        className: d(t.buttonBase, a),
        "data-cxy-name": "button-base",
        disabled: e,
        ref: n,
        ...o,
        ...m
      }
    );
  }
), E = c(
  ({ asChild: l, isLoading: a, loadingText: e, variant: s, ...o }, n) => /* @__PURE__ */ i(_, { children: a ? /* @__PURE__ */ i(u, { ...o, "aria-busy": a, disabled: a, ref: n, variant: s, children: /* @__PURE__ */ S(_, { children: [
    e || "Loading",
    /* @__PURE__ */ i(x, { size: "s", variant: s === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ i(u, { ...o, asChild: l, ref: n, variant: s }) })
), u = c(
  ({ className: l, isFullWidth: a, rounded: e, size: s, variant: o, ...n }, r) => /* @__PURE__ */ i(
    f,
    {
      className: d(
        D({ variant: o, size: s }),
        { [t.isFullWidth]: a, [t.rounded]: e },
        l
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: r,
      ...n
    }
  )
);
E.displayName = "Button";
f.displayName = "ButtonBase";
export {
  E as B,
  f as a,
  D as b
};
